import React, { useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
// import { useAppDispatch } from "src/app-redux/hooks";
// import { openDrawerAction } from "src/app-redux/settings/settingsSlice";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import WarningTwoToneIcon from "@mui/icons-material/WarningTwoTone";
import NatJanColorLogo from "src/assets/images/tfg_mainlogo.svg";
import { AuthRoute } from "src/modules/auth/auth.routes";
import { ROUTES } from "src/routes/routes";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    nested: {
      paddingLeft: theme.spacing(7),
    },
    ListItemIcon: {
      minWidth: "40px",
    },
  })
);

export function DrawerContent() {
  // const dispatch = useAppDispatch();
  const match = useRouteMatch();
  const classes = useStyles();

  const [expand, setExpand] = useState<string | undefined>(match.path);
  return (
    <div>
      <div className={classes.toolbar}>
        <Box my={1} textAlign="center">
          <img src={NatJanColorLogo} alt="logo" width="120" />
        </Box>
      </div>
      <List>
        {ROUTES.filter((r) => r.path !== AuthRoute.path).map((route, i) => (
          <div key={i}>
            <ListItem
              button
              component={NavLink}
              to={route.path}
              activeClassName="Mui-selected"
              // onClick={() => dispatch(openDrawerAction(false))}
              onClick={() => {
                // props.history.push(item.url);
                if (route.subRoutes?.length)
                  if (expand === route.path) setExpand(undefined);
                  else setExpand(route.path);
              }}
            >
              <ListItemIcon className={classes.ListItemIcon}>
                {route.icon ? <route.icon /> : <WarningTwoToneIcon />}
              </ListItemIcon>
              <ListItemText>
                <Typography variant="subtitle1">{route.title}</Typography>
              </ListItemText>
              {route.subRoutes?.length ? (
                expand === route.path ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : (
                ""
              )}
            </ListItem>
            {route.subRoutes
              ?.filter((ss) => !ss.noDrawer)
              ?.map((sub, j) => (
                <Collapse key={`${i},${j}`} in={expand === route.path} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={classes.nested}
                      component={NavLink}
                      to={`${route.path}${sub.path}`}
                      activeClassName="Mui-selected"
                    >
                      <ListItemText>
                        <Typography variant="body2">{sub.title}</Typography>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Collapse>
              ))}
          </div>
        ))}
      </List>
    </div>
  );
}
